"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tokenTypes = exports.loginTypes = exports.appTypes = void 0;
/**
 * Predefined tokens which the session management can currently handle
 */
var tokenTypes = exports.tokenTypes = /*#__PURE__*/function (tokenTypes) {
  tokenTypes["ciam"] = "ciam";
  tokenTypes["cscn"] = "cscn";
  return tokenTypes;
}(tokenTypes || {});
;

/**
 * The different application level login types
 */
var loginTypes = exports.loginTypes = /*#__PURE__*/function (loginTypes) {
  loginTypes["cscn"] = "cscn";
  loginTypes["icon"] = "icon";
  loginTypes["anonym"] = "anonym";
  loginTypes["callCenter"] = "callcenter";
  loginTypes["incompleteLoggedIn"] = "incompleteLoggedIn";
  loginTypes["incompleteLoggedInWl"] = "incompleteLoggedInWl";
  return loginTypes;
}(loginTypes || {});
;

/**
 * The CIAM equivalent application ids
 */
var appTypes = exports.appTypes = /*#__PURE__*/function (appTypes) {
  appTypes["cic"] = "002";
  appTypes["ekuss2"] = "003";
  appTypes["cscn"] = "004";
  appTypes["icon"] = "006";
  appTypes["iconWl"] = "010";
  return appTypes;
}(appTypes || {});
;

/**
 * Interface for the token refreshings
 */